export const loginAction = () => {
    return{
        type: 'LOG_IN'
    };
};

// export const pmAction = (data) => {
//     return{
//         type: 'PM',
//         payload: data
//     };
// }

// export const roleAction = (data) => {
//     return{
//         type: 'ASSIGN_ROLE',
//         payload: data
//     };
// }

export const updateAllGroupArrAction = (data) => {
    return{
        type: 'UPDATE_ALL_GROUPS',
        payload: data
    };
}

export const storeTeamAction = (data) => {
    return{
        type: 'STORE_TEAM',
        payload: data
    };
}
export const updateTeamAction = (data) => {
    return{
        type: 'UPDATE_STORE_TEAM',
        payload: data
    };
}
export const storeTeamNameAction = (data) => {
    return{
        type: 'STORE_TEAM_NAME',
        payload: data
    };
}
export const storeSponsorAction = (data) => {
    return{
        type: 'STORE_SPONSOR',
        payload: data
    };
}

export const findProjectManagerAction = (data) => {
    return{
        type: 'PM',
        payload: data
    };
}

export const storeQuizAction = (data) => {
    return{
        type: 'GET_QUIZ',
        payload: data
    };
}

export const storeSearchAction = (data) => {
    return{
        type: 'SEARCH_ITEM',
        payload: data
    };
}

export const storeMemberAction = (data) => {
    return{
        type: 'STORE_MEMBER',
        payload: data
    };
}


// student portal
export const storeQuizzesAction = (data) => {
    return{
        type: 'STORE_QUIZZES',
        payload: data
    };
}

export const addSingleQuestion = (data) => {
    return{
        type: 'STORE_SINGLE_QUESTION',
        payload: data
    };
}
export const pushQuestionToArray = (data) => {
    return{
        type: 'STORE_QUESTIONS',
        payload: data
    };
}
export const unassignedStudentAction = (data) => {
    return{
        type: 'STORE_STUDENT',
        payload: data
    };
}
export const updateUnassignedStudentAction = (data) => {
    return{
        type: 'UPDATE_UNASSIGNED_STUDENT_LIST',
        payload: data
    };
}

export const updateQuestionsList = (data) => {
    return{
        type: 'UPDATE_QUESTIONS_LIST',
        payload: data
    };
}
export const editQuestionAction = (data) => {
    return {
        type: 'STORE_QUESTION_FOR_EDITING',
        payload: data
    };
}

export const storeMultipleChoiceAction = (data) => {
    return {
        type: 'STORE_CHOICES',
        payload: data
    };
}

export const updateStoreMultipleChoiceAction = (data) => {
    return {
        type: 'UPDATE_CHOICES_LIST',
        payload: data
    };
}

export const cleanStoreMultipleChoiceAction = () => {
    return {
        type: 'CLEAN_CHOICES_LIST',
    };
}

export const storeFillBlankAction = (data) => {
    return {
        type: 'STORE_FILL_BLANK',
        payload: data
    };
}

// Admin - Quiz - New Assignmet - List 
export const storeQuizListAction = (data) => {
    return{
        type: 'STORE_QUIZ_LIST',
        payload: data
    };
}

export const updateQuizListAction = (data) => {
    return{
        type: 'UPDATE_STORE_QUIZ_LIST',
        payload: data
    };
}
 export const storeQuizIDAction = (data) =>{
     return {
         type: "STORE_QUIZ_ID",
         payload: data
     }
 }


 export const storeAllQuestionsAction = (data) => {
    return{
        type: 'STORE_ALL_QUESTIONS',
        payload: data
    };
}

export const storeGroupIDAction = (data) => {
    return{
        type: 'STORE_GROUP_ID',
        payload: data
    };
}

export const storeClassIDAction = (data) => {
    return{
        type: 'STORE_CLASS_ID',
        payload: data
    };
}

export const storeQuizForEditingAction = (data) => {
    return{
        type: 'STORE_QUIZ_FOR_EDITING',
        payload: data
    };
}
export const storeQuestionIdAction = (data) => {
    return{
        type: 'STORE_QUESTION_ID',
        payload: data
    };
}

export const storeAssignmentListArrAction = (data) => {
    return{
        type: 'STORE_ASSIGNMENTS_LIST_ARRAY',
        payload: data
    };
}

